const elements = document.getElementsByClassName('Layout--MenuToggle')
for (let element of elements) {
    element.addEventListener('click', handleMobileMenu(
        element,
        document.getElementById(element.dataset.targetId)
    ), {passive: true})
}

let modalTimeout = null
export function handleMobileMenu(toggleButton, modal) {
    return () => {
        if (modalTimeout) {
            clearTimeout(modalTimeout)
            modal.classList.remove('Closing')
        }

        const isOpen = toggleButton.ariaExpanded === 'true'
        const currentLabel = toggleButton.ariaLabel
        const toggleLabel = toggleButton.dataset.labelToggle

        if (isOpen) {
            toggleButton.ariaExpanded = 'false'
            modal.ariaHidden = 'true'
            modal.classList.add('Closing')
            modalTimeout = setTimeout(() => {
                modal.style.display = 'none'
                modal.classList.remove('Closing')
            }, 500)
        } else {
            toggleButton.ariaExpanded = 'true'
            modal.ariaHidden = 'false'
            modal.style.display = ''
        }

        toggleButton.ariaLabel = toggleLabel
        toggleButton.dataset.labelToggle = currentLabel

        setTimeout(() => {
            document.body.classList.toggle('Layout--MobileMenuOpened')
            modal.classList.toggle('FixedOpen')
            toggleButton.classList.toggle('Close')
        }, 10)
    }
}
